import type { IconData } from '@stacksjs/iconify-core'

export const horizontalMenuCircleFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 1.5C11.574 1.5 1.5 11.574 1.5 24S11.574 46.5 24 46.5S46.5 36.426 46.5 24S36.426 1.5 24 1.5\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M24 27.5a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7M16 24a3.5 3.5 0 1 1-7 0a3.5 3.5 0 0 1 7 0m19.5 3.5a3.5 3.5 0 1 0 0-7a3.5 3.5 0 0 0 0 7\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default horizontalMenuCircleFlat
